import {Route, Switch} from "react-router-dom";
import {urlService} from "../../routing/urlsService";
import React from "react";
import PublisherDataPoint from "./PublisherDataPoint/PublisherDataPoint";
import PublisherDataPoints from "./PublisherDataPoints";
import {Server} from "@leap4/auth";
import {Grid} from "@leap4/frontend";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";


function PublisherDataPointsModule() {
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <Grid direction="row" alignItems="center" container>
            <Switch>
                {/* WARNNING: Never warp <Route/> with another component (even Grid)*/}
                <Route exact path={urlService.publisherDataPoints()} component={PublisherDataPoints}/>
                <Route exact path={urlService.publisherDataPoint()} component={PublisherDataPoint}/>
            </Switch>
        </Grid>
    )
}


export default PublisherDataPointsModule